import React from 'react';
import './Timeline.scss';

const Timeline = ({ 
    communities, 
    dates, 
    data, 
    getDayStatus, 
    getStatusColor, 
    getStatusTooltip,
    hoveredItem,
    setHoveredItem
}) => {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' });
    };

    const formatDateFull = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    return (
        <div className="timeline-container">
            <div className="timeline-header">
                <h4 className="timeline-title">Временная шкала активности</h4>
                <p className="timeline-subtitle">
                    Визуализация данных активности по дням и группам
                </p>
            </div>
            
            <div className="timeline-scroll">
                <div className="timeline-inner">
                    {/* Заголовки дат */}
                    <div className="timeline-row header-row">
                        <div className="timeline-group-header">
                            <span>Группа</span>
                        </div>
                        {dates.map((date, index) => (
                            <div 
                                key={date} 
                                className={`timeline-date-cell ${index % 7 === 0 ? 'alt' : ''}`}
                            >
                                <div className="timeline-date">{formatDate(date)}</div>
                                <div className="timeline-weekday">
                                    {new Date(date).toLocaleDateString('ru-RU', { weekday: 'short' })}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Строки сообществ */}
                    {communities.map((community, cIndex) => (
                        <div 
                            key={community.id} 
                            className={`timeline-row ${cIndex % 2 === 0 ? 'alt' : ''}`}
                        >
                            <div className="timeline-group-info">
                                <div className="group-name" title={community.name}>{community.name}</div>
                                <div className="group-id">ID: {community.id}</div>
                            </div>
                            
                            {dates.map((date) => {
                                const status = getDayStatus(community.id, date);
                                const isHovered = hoveredItem && 
                                    hoveredItem.communityId === community.id && 
                                    hoveredItem.date === date;
                                
                                return (
                                    <div 
                                        key={`${community.id}-${date}`}
                                        className={`timeline-cell ${isHovered ? 'hovered' : ''}`}
                                        onMouseEnter={() => setHoveredItem({ communityId: community.id, date })}
                                        onMouseLeave={() => setHoveredItem(null)}
                                        title={getStatusTooltip(community.id, date)}
                                    >
                                        <div className={`cell-status ${getStatusColor(status)}`}></div>
                                        
                                        {isHovered && (
                                            <div className="timeline-tooltip">
                                                <div className="tooltip-name">{community.name}</div>
                                                <div>{formatDateFull(date)}</div>
                                                <div className="tooltip-status">
                                                    {status === 'empty' && 'Нет данных'}
                                                    {status === 'single' && 'Одно значение'}
                                                    {status === 'duplicate' && 'Есть дубли'}
                                                </div>
                                                <div className="tooltip-arrow"></div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>

            {/* Итоговая статистика */}
            <div className="timeline-summary">
                <div className="timeline-stats">
                    <div className="stat-item">
                        <div className="stat-color bg-gray"></div>
                        <span>Нет данных: {
                            communities.reduce((count, c) => (
                                count + dates.filter(d => getDayStatus(c.id, d) === 'empty').length
                            ), 0)
                        }</span>
                    </div>
                    <div className="stat-item">
                        <div className="stat-color bg-green"></div>
                        <span>Одно значение: {
                            communities.reduce((count, c) => (
                                count + dates.filter(d => getDayStatus(c.id, d) === 'single').length
                            ), 0)
                        }</span>
                    </div>
                    <div className="stat-item">
                        <div className="stat-color bg-red"></div>
                        <span>Дубли: {
                            communities.reduce((count, c) => (
                                count + dates.filter(d => getDayStatus(c.id, d) === 'duplicate').length
                            ), 0)
                        }</span>
                    </div>
                    <div className="stat-item">
                        <div className="stat-color bg-blue"></div>
                        <span>Всего ячеек: {communities.length * dates.length}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Timeline;
